export default __webpack_public_path__ + "static/media/SoulTreeApartment.a48868d3.webp";